import { formatText } from "../../../components/CommonComponents/CommonFunctions";
import { urlEncodedId } from "../../../components/CommonComponents/encodeDecodeFunction";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Button, Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";

export const EnrollCard = ({ courseDetails, isEnroll }) => {
  const navigate = useNavigate();
  if (!courseDetails) return null;

  const lessons =
    (courseDetails?.lessonByLanguage?.englishLessons?.length || 0) +
    (courseDetails?.lessonByLanguage?.hindiLessons?.length || 0);

  const infoList = [
    {
      icon: "fas fa-book-open",
      label: "Lessons",
      value: lessons,
    },
    {
      icon: "fas fa-clipboard-check",
      label: "Assessment",
      value:
        courseDetails?.assessmentType
          ?.toLowerCase()
          .replace(/\b\w/g, (char) => char.toUpperCase()) || "-",
    },
    {
      icon: "fas fa-calendar-alt",
      label: "Published",
      value: courseDetails?.publishedOnDate || "-",
    },
  ];

  return (
    <Card className="enroll-card sticky-top">
      <CardBody>
        <div className="price">
          <span className="price-label">Course Fees</span>

          <span className="price-value">
            {courseDetails?.accessType === "FREE"
              ? "Free"
              : `₹${courseDetails?.coursePrice || 0}`}
          </span>
        </div>

        {isEnroll && (
          <Button
            color="primary"
            className="enroll-btn"
            block
            onClick={() =>
              navigate(
                `/user/web-view-course-enroll/${urlEncodedId(courseDetails?.ID)}`,
              )
            }
          >
            ENROLL NOW
          </Button>
        )}

        <div className="info-list mt-4">
          {infoList.map((item) => (
            <div className="info-row" key={item.label}>
              <div className="info-label">
                <i className={`${item.icon} mr-2`} />
                {item.label}
              </div>

              <div className="info-value">{item.value}</div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

const getShortDescription = (html) => {
  if (!html) return "No description available.";
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = div.textContent || div.innerText || "";
  return text.length > 250 ? `${text.substring(0, 250)}...` : text;
};

/* COURSE HEADER */
export const CourseHeaderCard = ({
  courseDetails,
  isEnroll,
  showEnrollButton = true,
  showAddTraineeButton = false
}) => {

  const navigate = useNavigate();
  // const [previewOpen, setPreviewOpen] = useState(false);
  const [isThumbnailModalOpen, setIsThumbnailModalOpen] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);



  const mediaUrl = courseDetails.thumbnailPath || "";
  const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(mediaUrl);
  const toggleThumbnailModal = () => setIsThumbnailModalOpen((prev) => !prev);


  const enrollmentStatus = courseDetails?.enrollmentStatus;

  const statusClassMap = {
    ENROLLED: "enrollPage-btn-enrolled",
    PENDING: "enrollPage-btn-pending",
    // NOT_ENROLLED: "enrollPage-btn-not-enrolled",
  };

  const isNavigationDisabled =
    enrollmentStatus === "ENROLLED" || enrollmentStatus === "PENDING";


  if (!courseDetails) return null;

  return (
    <>
      <div className="course-hero-wrapper">
        <Card className="course-hero-card">
          <CardBody className="p-3">
            <Row className="align-items-start">
              <Col lg="8">
                <div className="course-badges mb-3">
                  <span
                    className={`radio-badge ${courseDetails?.courseType?.toLowerCase() === "live"
                        ? "live"
                        : "recorded"
                      }`}
                  >
                    <span className="radio-circle">
                      <span className="radio-dot" />
                    </span>
                    {courseDetails?.courseType}
                  </span>
                </div>

                <h1 className="course-title">{courseDetails?.courseName}</h1>

                <p className="course-short-desc mb-3">
                  {getShortDescription(courseDetails?.courseDescription)}
                </p>
                <div className="channelPartner-course-info-bar">
                  {/* <div className="info-item">
            <i className="fa fa-clock info-icon"></i>
            <div>
              <h4 className="text-default mb-0">{courseDetails?.totalCourseDuration || 0}</h4>
              <p className="small-text">Duration</p>
            </div>
          </div> */}

                  <div className="info-item">
                    <i className="fa fa-users info-icon"></i>
                    <div>
                      <h4 className="text-default mb-0">{courseDetails?.totalEnrolledUsers || 0}</h4>
                      <p className="small-text">Trainees</p>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      {courseDetails?.courseLanguage === "ENGLISH"
                        ? "E"
                        : courseDetails?.courseLanguage === "HINDI"
                          ? "H"
                          : "EH"}
                    </div>

                    <div>
                      <h4 className="text-default mb-0">{formatText(courseDetails?.courseLanguage)}</h4>
                      <p className="small-text">Language</p>
                    </div>
                  </div>

                  <div className="info-item">
                    <i className="fa fa-signal info-icon"></i>
                    <div>
                      <h4 className="text-default mb-0">{formatText(courseDetails?.level)}</h4>
                      <p className="small-text">Level</p>
                    </div>
                  </div>

                  <div className="info-item">
                    <i className="fa fa-award info-icon"></i>
                    <div>
                      <h4 className="text-default mb-0">
                        {courseDetails?.enableCeritificate === true ? "Yes" : "No"}
                      </h4>
                      <p className="small-text">Certificate</p>
                    </div>
                  </div>

                  <div className="info-item">
                    <i className="fa fa-star info-icon"></i>
                    <div>
                      <h4 className="text-default mb-0">{courseDetails?.averageRating || "0"}</h4>
                      <p className="small-text">Rating</p>
                    </div>
                  </div>
                </div>

              </Col>

              <Col lg="4" className="text-center mt-4 mt-lg-0">
                {/* {showAddTraineeButton && <Button
                color="primary"
                 className="btn-deep-blue add-trainee-btn-position"
                  onClick={() => {
                     navigate(`/channel-partner/web-view-course-enroll/course/${urlEncodedId(courseDetails?.ID)}/add-trainees`)
                   }}
                  >
                   <i className="fa fa-plus mr-1" />
                    Add Trainees
                </Button>}     */}
                <div className={`channelPartner-hero-image-wrapper`}>


                  {/* <img
                    src={courseDetails?.thumbnailPath}
                    alt={courseDetails?.courseName}
                    className="hero-image"
                    onClick={() => setPreviewOpen(true)}
                  /> */}
                  <div
                    className="channelPartner-hero-image-wrapper cursor"
                    onClick={() => {
                      // setPreviewOpen(true);
                      toggleThumbnailModal();
                    }}
                    title="Click to preview"
                  >
                    {isVideo ? (
                      <div className="video-thumbnail">
                        <video
                          src={mediaUrl}
                          className="hero-image"
                          muted
                          preload="metadata"
                        />
                        <div className="play-overlay">
                          <i className="fa fa-play"></i>
                        </div>
                      </div>
                    ) : (
                      <img
                        src={mediaUrl}
                        alt={courseDetails?.courseName}
                        className="hero-image"
                      />
                    )}
                  </div>



                  {showEnrollButton && isEnroll && (
                    <Button
                      color="primary"
                      className={`enrollPage-btn image-enroll-btn ${statusClassMap[enrollmentStatus] || ""
                        }`}
                      disabled={isNavigationDisabled}
                      onClick={() => {
                        if (isNavigationDisabled) return;

                        navigate(
                          `/channel-partner/course/${urlEncodedId(courseDetails?.ID)}`
                        );
                      }}
                    >
                      {enrollmentStatus === "ENROLLED"
                        ? "Already Enrolled"
                        : enrollmentStatus === "PENDING"
                          ? "Enrollment Pending"
                          : courseDetails?.accessType === "FREE"
                            ? "Enroll for Free"
                            : `Enroll Now ₹${courseDetails?.coursePrice}`}
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>


        <Modal
          isOpen={isThumbnailModalOpen}
          toggle={toggleThumbnailModal}
          size="xl"
          centered
          className="certificate-preview-modal"
        >
          <ModalHeader toggle={toggleThumbnailModal}>
            Thumbnail Preview
          </ModalHeader>
          <ModalBody className="certificate-preview-modal-body">
            {isVideo ? (
              <video
                src={courseDetails.thumbnailPath}
                controls
                autoPlay
                className="w-100"
                onLoadedData={() => setIsPreviewLoading(false)}
                onError={() => setIsPreviewLoading(false)}
              />
            ) : (
              <img
                src={courseDetails.thumbnailPath}
                alt="Thumbnail Preview"
                className="certificate-preview-modal-image"
                onLoad={() => setIsPreviewLoading(false)}
                onError={() => setIsPreviewLoading(false)}
              />
            )}
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};
